import { useEffect } from 'react';

export function useKeydown(key: string, callback: () => void) {
  useEffect(() => {
    const handleKeyDown = (event: { key: string }) => {
      if (event.key === key) {
        callback();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, key]);
}
